module.exports = __webpack_public_path__ + "img/user_have.7aa16891.png";